import { ChangeDetectionStrategy, Component, DoCheck, EventEmitter, forwardRef, IterableDiffers, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChildren, ViewContainerRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ViewChild, AfterViewInit, ElementRef, Renderer2, HostListener, Input, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
// import * as $ from 'jquery';
import $ from 'jquery';

import 'src/assets/jquery/jquery.atwho.js';
import 'src/assets/jquery/jquery.caret.js';
import { ChangeDetectorRef } from '@angular/core';
import { AttendeeDialogComponent } from 'src/app/components/attendee-dialog/attendee-dialog.component';
import { attendee } from 'src/app/models/attendee';
import { AttendeeService } from 'src/app/service/attendee.service';
import { Globals } from 'src/app/service/global';
import { environment, environment_const, environment_msg } from 'src/environments/environment';
import { snackbarConfigurations } from 'src/environments/environment';
import { AttendeeCollabDetails, MeetingResponse } from 'src/app/models/basicMeetingModel';
import { WebsocketService } from 'src/app/service/websocket.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';

import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, } from '@angular/material/snack-bar';
import { UtilityService } from 'src/app/service/utility.service';

import { NotifierService } from 'angular-notifier';
import { inspect } from 'util';
import { TrackAttendeeDialogComponent } from '../track-attendee-dialog/track-attendee-dialog.component';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { Breakpoints,BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues } from 'src/environments/environment';
import { PermissionService } from 'src/app/service/permission.service';
import { data } from 'jquery';
@Component({
  selector: 'app-instant-participants',
  templateUrl: './instant-participants.component.html',
  styleUrls: ['./instant-participants.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InstantParticipantsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InstantParticipantsComponent),
      multi: true,
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default

})
export class InstantParticipantsComponent implements OnInit, DoCheck {

  //participant accordion expansion input and normal variables
  @Input()
  participantExpansion!: boolean;
  expansion = true
  @Input() accordionExpansion: any;
  @Input() checkUserAvailability :any;
  //guest participant color indication variable
  guestParticipantColor: any;

  //participant placeholder text
  placeholder = "Press '@' to add/view the list of Groups/Individuals";

  //participant check box
  checkedParticipant: any;

  //dropdown selected value
  selected: any;

  //UI team variable declaration
  loaderVisibility = false;

  @ViewChild("parent") private parentRef!: ElementRef<HTMLElement>;

  @Input() meetingResponse!: MeetingResponse;
  attendeeObj: attendee[] = [];
  subscriptions: Subscription[] = [];
  matDialogRef!: MatDialogRef<AttendeeDialogComponent>;
  roleListData: any = [];
  attUserId: any;
  differ: any;
  dataToParent!: any;
  actualTxt: any;
  myFlagForSlideToggle = true;  
  isChecked = true;
  docheckFlag =true;
  attendeeRoleCode!: string;
  attendeeRole!: string;
  roleCodeVal: any;
  attId: any;
  private readonly notifier!: NotifierService;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  pastMeetingTourValues = pastMeetingTourValues
  //snackbar
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  userAvailability: String = "Tentative";
  @Output() latestMeetingResponse: any = new EventEmitter();
  attendeeLogData: any = [];
  attendeeIsPresent: any = true;
  absent: boolean = false;
  present:boolean = true;
  absentFlag!:boolean;
  tenLabel: any;
  attendeeCollabDetails=<AttendeeCollabDetails>{};

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
    );
    isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Medium
    )
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
    )
    isLarge: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Large
    )
    isExtraLarge: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.XLarge
    )
  disableRoleList = false;
  attendeeJson: any;
  editAttendeeJson: any;
  numberOfIndexToBeLimit: any;
  commonAttendeeLength: number | undefined;
  attendeeLength = 0;
  showMoreAttendee : any = [];
  showMoreButtonToggle = false
  disableParticipant: any;
  participantContentEditable: any;
  @Input() contenteditableBool : any;
  meetingResp: any;
  conflictTime: any;
  availableStatus: any;
  attendeeInformation: any;
  userId:any;
  constructor(private permissionService:PermissionService,private dialog : MatDialog,private readonly breakpointObserver: BreakpointObserver,public sideNav : SideNavServiceService,private _snackBar: MatSnackBar, private cdref: ChangeDetectorRef, private attendeeService: AttendeeService, private matDialog: MatDialog, private globals: Globals, private differs: IterableDiffers, private utility: UtilityService, private websocketService: WebsocketService, private webTranService: WebsocketTransferService, private notifierService: NotifierService) {
    this.differ = differs.find([]).create(undefined);
    this.notifier = notifierService;
    this.userId=localStorage.getItem('userId');
    
  }
  ngOnInit() {
    
    this.attendeeService.getData().subscribe((data: any) => {
      this.meetingResponse.attendeeList?.forEach(element => {
       if(element.attendeeId == data.attendeeId){
        element.logType = data.logType;        
       }
});
    });
    this.roleListData = this.globals.userRoleList;
     
  }
  ngAfterViewInit() {
    

    this.loadUserInfo();
    if(!this.contenteditableBool){
      document.getElementById('insertAttendeeSec')?.setAttribute('contenteditable','false')
    }
    if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
      this.sideNav.disablePageAfterApproval();
    }else{
      this.sideNav.enableAfterApproveToNormal();
    }

    
  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  trackAttendeeDialog(attendeeId: any,attendeeObj:any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.READ);
    
    if(!roleFlag){
      return;
    }
    
    const logArray: any = [];

    this.attendeeService.getAttendeeLog(attendeeId).subscribe((data: any) => {
      this.attendeeLogData = data.body;
      this.attendeeLogData.forEach((element: any) => {
        const logTime = element.logTime;
        const time = new Date();
        var currentTime = time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
        const curSysDate = new Date(logTime);
        const meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
        const fullDate = new Date(meetUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
        const hour = this.addZero(fullDate.getHours());
        const minutes = this.addZero(fullDate.getMinutes());
        const seconds = this.addZero(fullDate.getSeconds());
        var currentTime = hour + ":" + minutes + ":" + seconds;
        
        element.logTime = currentTime;
        logArray.push(element);
      });
      const trackOpen = this.matDialog.open(TrackAttendeeDialogComponent, {
        data: { "logData": logArray , "agendaList":this.meetingResponse.agendaList, "attendeeObj": attendeeObj, "meetingResponse":this.meetingResponse},
        panelClass: ['animate__animated','animate__slideInRight'],
          disableClose: true,
          position : {
            left : "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width : "50%",
          height : "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          trackOpen.updateSize('70vw','100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          trackOpen.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          trackOpen.updateSize('100vw', '100vh');
        } 
      });
      trackOpen.afterClosed().subscribe(result => {
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        mediumDialogSubscription.unsubscribe()
      });
    })

  }
  
  ngOnChanges() {
    this.expansion = this.accordionExpansion;
    
    //this.meetingResponse.attendeeList = this.checkUserAvailability.attendeeList;
    
  }


  ngAfterContentChecked() {
  }

  ngAfterViewChecked(){
  }



  loadAtwho($inputor: any) {
    $inputor.off("inserted.atwho");
    $inputor.on("inserted.atwho", (_$event: any, _$li: any, _query: any) => {


      if (_$li != 0) {

        const addAttendeejsonobj = {
          "attendeeName": _$li.data('item-data').value,
          "attendeeEmail": _$li.data('item-data').email,
          "fkCodelstAttendeeRole": 7,
          "attendeeIsPresent": environment.AttendeeIsPresent,
          "attendeeId": "",
          "fkSecUserAttendee": _$li.data('item-data').id,
          "attendeeRole": "Attendee",
          "createdBy": _$li.data('item-data').id,
          "attendeeRoleCode": environment.defAttendeeRoleCode,
          "meetingId": this.meetingResponse.meetingId,
          "logType": this.globals.logType, 
          "isGuestUser": _$li.data('item-data').isExternal,
          "availableStatus": ""       
        }  
        
        const userId=_$li.data('item-data').id+",";
        
        const reqCheckUserAvailability={
  
          "attendeeDetails": userId,
          "duration": this.meetingResponse.duration,
          "meetingDate": this.meetingResponse.meetingDateShortFormat,
          "meetingId": this.meetingResponse.meetingId,
          "meetingStartTime": this.meetingResponse.meetingStartTime,
          "timeZone": this.meetingResponse.visitorTimeZone,
          "userId": _$li.data('item-data').id,
          "orgCode": localStorage.orgCode
        
      }
      let conflictMap :any =[];
      let conflictTime= ""
      const attendeeInformation: any = []
      if(this.meetingResponse.meetingTemplateFlag==null){
        this.attendeeService.checkUserAvailability(reqCheckUserAvailability).subscribe((dataObj) => {
          if(dataObj.conflictTimingsMap){
            
            const objectAccessor = dataObj.conflictTimingsMap
            let store : any = [];
            store = Object.values(objectAccessor)
            if(store[0].length != 0){
              
              for(let i=0; i < store[0].length;i++){
                addAttendeejsonobj.availableStatus = "Tentative" 
                  conflictMap = Object.values(objectAccessor)[i]
                  
                  if(Object.values(objectAccessor)[i] != undefined){
                  conflictMap.forEach((elem:any) => {
                    
                    attendeeInformation.push(elem.meetingType)
                    if(conflictMap.length >1){
                      conflictTime +=  elem.conflictStarttime +" - "+ elem.conflictEndtime +","+" ";
                      }else{
                      conflictTime +=  elem.conflictStarttime +" - "+ elem.conflictEndtime;
      
                      }
                  });
                   
                   this.conflictTime = conflictTime;
                   this.attendeeInformation = attendeeInformation
              }
            }
            }
            else{
              
              addAttendeejsonobj.availableStatus = "Available" ;
            }
          }
        });
        } 
        this.saveParticipant(addAttendeejsonobj);
      }
    });
  }


  saveParticipant(jsonRequest: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.ADD);
    
    if(!roleFlag){
      return;
    }
    this.attendeeService.addAttendee(jsonRequest).subscribe((data) => {     
      const attObj = jsonRequest;
      attObj["attendeeId"] = data.attendeeId;
      attObj["fkCodelstAttendeeRole"] = data.fkCodelstAttendeeRole;
      attObj["attendeeIsPresent"] = data.attendeeIsPresent;
      attObj["attendeeRole"] = data.attendeeRole;
      attObj["createdBy"] = data.createdBy;
      attObj["deletedFlag"] = data.deletedFlag;
      attObj["logType"] = "IN";
      attObj["isGuestUser"] = data.isGuestUser;
      attObj["conflictTime"]=this.conflictTime;
      attObj["attendeeMeetingInformation"]=this.attendeeInformation
      attObj["availableStatus"]=jsonRequest.availableStatus;
      // attObj["availableStatus"] = this.userAvailability
      attObj["isJoined"]=""

      this.meetingResponse.attendeeList?.push(attObj);
      $("#insertAttendeeSec").empty();

      //added for collaboration
      this.attendeeCollabDetails=<AttendeeCollabDetails>{};
      this.attendeeCollabDetails.elementVal=attObj;
      this.attendeeCollabDetails.actionType="A";
      this.attendeeCollabDetails.collabType="ATTENDEE";
      this.attendeeCollabDetails.userId=localStorage.getItem("userId");
      this.attendeeCollabDetails.elementId=data.attendeeId;
      this.attendeeCollabDetails.meetingId=this.meetingResponse.meetingId;
      //close
      if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
        this.attendeeCollabDetails.meetTypeVal=this.meetingResponse.meetingType;
      }
        
      this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.attendeeCollabDetails).subscribe((data) => {
        //

      });
      this.trackMeetingResponse();
      this.loaderVisibility = true;
      $("#displayAttendeeSec").find('.atwho-inserted').remove();

    }).add(() => {
      //
      $("#displayAttendeeSec").removeClass(".atwho-inserted");
      this.cdref.markForCheck();
      this.loaderVisibility = false;
    });
  }
  trackMeetingResponse() {
    //this.latestMeetingResponse.emit(this.meetingResponse);
    //this.websocketService._send(this.meetingResponse);
  }

  brRemover(e: any): boolean {
    const insertAttendeeSec = document.getElementById("#insertAttendeeSec")?.innerHTML;
    // //
    if (e.keyCode == 13 && insertAttendeeSec != "") {
      // window.alert("called")
      return false;
    }
    else if (e.keyCode == 13 && insertAttendeeSec == "") {
      return false;
    }
    $('#insertAttendeeSec').find('br').remove();
    return true

  }

  ngDoCheck() {
    const attendeeChip = this.meetingResponse.attendeeList;
    this.commonAttendeeLength = attendeeChip?.length;
    const pageIns = this;
    const changes = this.differ.diff(this.meetingResponse.attendeeList);
    if (changes) {
      const extraSmallScreen = this.isExtraSmall.subscribe(size => {
        if(size.matches){
          this.numberOfIndexToBeLimit = 1
          if(this.commonAttendeeLength! > this.numberOfIndexToBeLimit){      
            this.attendeeLength = this.commonAttendeeLength! - this.numberOfIndexToBeLimit;
            this.showMoreButtonToggle = true
          }
          else{
            this.showMoreButtonToggle = false
          }
        }
      })
      const mediumScreen = this.isMedium.subscribe(size => {
        if(size.matches){
          this.numberOfIndexToBeLimit = 3
          if(this.commonAttendeeLength! > this.numberOfIndexToBeLimit){      
            this.attendeeLength = this.commonAttendeeLength! - this.numberOfIndexToBeLimit;
            this.showMoreButtonToggle = true
          }
          else{
            this.showMoreButtonToggle = false
          }
        }
      })
      const smallScreen = this.isSmall.subscribe(size => {
        if(size.matches){
          this.numberOfIndexToBeLimit = 2
          if(this.commonAttendeeLength! > this.numberOfIndexToBeLimit){      
            this.attendeeLength = this.commonAttendeeLength! - this.numberOfIndexToBeLimit;
            this.showMoreButtonToggle = true
          }
          else{
            this.showMoreButtonToggle = false
          }
        }
      })
      const largeScreen = this.isLarge.subscribe(size => {
        if(size.matches){
          this.numberOfIndexToBeLimit = 6
          if(this.commonAttendeeLength! > this.numberOfIndexToBeLimit){      
            this.attendeeLength = this.commonAttendeeLength! - this.numberOfIndexToBeLimit;
            this.showMoreButtonToggle = true
          }
          else{
            this.showMoreButtonToggle = false
          }
        }
      })
      const extraLargeScreen = this.isExtraLarge.subscribe(size => {
        if(size.matches){
          this.numberOfIndexToBeLimit = 8
          if(this.commonAttendeeLength! > this.numberOfIndexToBeLimit){      
            this.attendeeLength = this.commonAttendeeLength! - this.numberOfIndexToBeLimit;
            this.showMoreButtonToggle = true
          }
          else{
            this.showMoreButtonToggle = false
          }
        }
      })
      changes.forEachAddedItem((r: any) => {
        this.attendeeRole = r.item.attendeeRole;
        setTimeout(function () {
          pageIns.loadUserInfo();
        }, 5);

      });
      changes.forEachRemovedItem((r: any) => {
        setTimeout(function () {
          pageIns.loadUserInfo();
          pageIns.trackMeetingResponse();
        }, 5);
      });
    }
    
  }

  loadUserInfo() {
    this.attendeeService.loadAttendeeAgendaPresenter(true, "ATT", null)
      .then((result: any) => {
        this.loadAtwho(result);
        const roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.ADD);
        const insertAttendeeSec = <HTMLElement>document.getElementById("insertAttendeeSec");
          if(!roleFlag){
            this.disableParticipant = true;
            // $("#insertAttendeeSec").attr('contenteditable', false);            
            if(insertAttendeeSec!=null && insertAttendeeSec!=undefined){
              insertAttendeeSec.contentEditable = 'false';
            }
          }else{
            this.disableParticipant = false;
            if(insertAttendeeSec!=null && insertAttendeeSec!=undefined){
              insertAttendeeSec.contentEditable = 'true';
            }
          }
          
      });
  }

  deleteAttendee(obj: any, attendeeobj: any, attendeeRole: any) {  
    if ((attendeeRole == "FAC" ) && ($("#displayAttendeeSec").find('div#roleCode_CP').length <= 0)) {
      
      this.sideNav.alertChangeFacilitator('changeFAC');
    }else if((attendeeRole == "CP") && ($("#displayAttendeeSec").find('div#roleCode_FAC').length <= 0 && $("#displayAttendeeSec").find('div#roleCode_CP').length <= 1)){
      
      this.sideNav.alertChangeChairPerson('ChangeCp');
    } else {
      this.dialog.open(ConfirmDialogComponent, {
          
        data: {
          dialogTitle : "Confirmation",
          dialogContent : environment_msg.msg_confirm_delete_participant
        },
      }).afterClosed().subscribe(response => {

        
        if(response == true){
          this.attendeeService.deleteAttendee(obj).subscribe((data) => {
            const index = this.meetingResponse.attendeeList?.indexOf(attendeeobj);
            if (index !== -1 && index != null) {
              this.meetingResponse.attendeeList?.splice(index, 1);
            }
            this.meetingResponse.attendeeList = this.meetingResponse.attendeeList;

            //added for collaboration
            this.attendeeCollabDetails=<AttendeeCollabDetails>{};
            this.attendeeCollabDetails.elementVal=attendeeobj;
            this.attendeeCollabDetails.actionType="D";
            this.attendeeCollabDetails.collabType="ATTENDEE";
            this.attendeeCollabDetails.userId=localStorage.getItem("userId");
            this.attendeeCollabDetails.elementId=attendeeobj.attendeeId;
            this.attendeeCollabDetails.meetingId=this.meetingResponse.meetingId;
            if(this.meetingResponse.meetingType!= undefined && this.meetingResponse.meetingType!=null&& this.meetingResponse.meetingType!=""){
              this.attendeeCollabDetails.meetTypeVal=this.meetingResponse.meetingType;
            }
              
            //close

            this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.attendeeCollabDetails).subscribe((data) => {
              //

            });


            //
          }).add(() => {
            //this.loadUserInfo();
            this.cdref.markForCheck();
          });
        }
      });
    }
  }
  editAttendeeModal(obj: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }

    this.meetingResponse.attendeeList?.forEach((attlistElemt: any) => {
      if(attlistElemt.attendeeRoleCode == "FAC"){
        this.editAttendeeJson = attlistElemt;
      }
    });

    this.matDialogRef = this.matDialog.open(AttendeeDialogComponent, {
      data: {
        attendeeList:this.meetingResponse.attendeeList,
        roleList: this.roleListData,
        attendeeName: obj.attendeeName,
        attendeeEmail: obj.attendeeEmail,
        attRole: obj.attendeeRoleCode,
        attUserId: obj.fkSecUserAttendee,
        attendeeRole: obj.attendeeRole,
        fkCodelstAttendeeRole: obj.fkCodelstAttendeeRole,
        attendeeRoleCode: obj.attendeeRoleCode,
        attendeeId: obj.attendeeId,
        attendeeDes: obj.attendeeRole,
        isGuestUser: obj.isGuestUser,
        isJoined: obj.isJoined,
        attendeejson: this.editAttendeeJson,
        availableStatus : obj.availableStatus,
        logType:obj.logType,
        attendeeIsPresent: obj.attendeeIsPresent
      },
      panelClass: ['animate__animated','animate__slideInRight'],
          disableClose: true,
          position : {
            left : "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width : "50%",
          height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('100vw', '100vh');
      }       
    });
    this.matDialogRef.afterClosed().subscribe(dataFromChild => {
      
      if (dataFromChild != false) {
        this.dataToParent = dataFromChild;
        this.modifyAttendeeAfterEdited(this.dataToParent, obj);
      }    

      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    });

  }
  modifyAttendeeAfterEdited(dataObj: any, attdata: any) {
    const index = this.meetingResponse.attendeeList?.indexOf(attdata);
    //
    if (index !== -1 && index != null) {
      const attobj =
      {
        "attendeeName": dataObj.attendeeName,
        "attendeeEmail": dataObj.attendeeEmail,
        "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
        "attendeeIsPresent": dataObj.attendeeIsPresent,
        "attendeeId": dataObj.attendeeId,
        "fkSecUserAttendee": dataObj.fkSecUserAttendee,
        "attendeeRole": dataObj.attendeeRole,
        "createdBy": dataObj.createdBy,
        "attendeeRoleCode": dataObj.attendeeRoleCode,
        "deletedFlag": 0,
        // "logType": "IN",
        "logType": dataObj.logType,
        "isJoined":dataObj.isJoined,
        "availableStatus": dataObj.availableStatus,
        "isGuestUser":dataObj.isGuestUser
      }
      this.meetingResponse.attendeeList?.splice(index, 1, attobj);
      
      // this.attendeeService.fetchAttendee(dataObj.meetingId).subscribe((data:any)=>{
      //   this.meetingResponse.attendeeList = data;
      // });
    }
    this.cdref.markForCheck();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  shortRoleName(roleCode: any) {
    return roleCode.slice(0, 1);
  }

  getRoleListValues(event: any) {
    const objElm = HTMLElement = event;
  }

  roleValue(attId: any) {

    this.meetingResponse.attendeeList?.forEach((attlistElemt: any) => {
      if (attlistElemt.attendeeId == attId) {
        this.roleCodeVal = attlistElemt.attendeeRoleCode;
        this.attId = attId;
        if(attlistElemt.isGuestUser == 1){
          this.disableRoleList = true;
        }else{
          this.disableRoleList = false;
        }
      }
      if(attlistElemt.attendeeRoleCode == "FAC"){
        this.attendeeJson = attlistElemt;
      }
    });
    const attendeeRoleVal = document.getElementsByClassName('global-border-container-item');
    let roleCode = "";
    for (let i = 0; i < attendeeRoleVal.length; i++) {
      roleCode += attendeeRoleVal[i].getAttribute("attendeeRoleCode") + ",";
    }
  }


  loadGuestUser(e: any) {

    if (e.which == 13) {
      //
      this.actualTxt = "";
      if ($("#insertAttendeeSec").find('.atwho-query').length > 0) {
        this.actualTxt = $("#insertAttendeeSec").find(".atwho-query").text().slice(1);
        this.guestParticipantColor = true;
        const tempId = document.getElementById("insertAttendeeSec");
        if (tempId != null) {
          //  window.alert("called")
          tempId.innerHTML = ""
        }
      } else {
        $("#insertAttendeeSec").find('.atwho-inserted').text('');
        $("#displayAttendeeSec").find('.atwho-inserted').remove();
        const tempId = document.getElementById("insertAttendeeSec");
        //
        if (tempId != null) {
          //  window.alert("called")
          tempId.innerHTML = ""
        }
      }
      $("#insertAttendeeSec").find(".atwho-query").remove()
      if (this.actualTxt != null && this.actualTxt != "" && this.actualTxt != undefined && this.actualTxt != "null") {
        // window.alert("Participants saved...")
        $("#insertAttendeeSec").find('.atwho-inserted').text('');
        $("#displayAttendeeSec").find('.atwho-inserted').remove();
        const guestUserjsonobj = {
          "attendeeName": this.actualTxt,
          "attendeeEmail": "",
          "attendeeId": "",
          "attendeeRole": "",
          "attendeeRoleCode": environment.defAttendeeRoleCode,
          "meetingId": this.meetingResponse.meetingId,
          "isGuestUser": 1,
          "availableStatus":"Available",
          "createdBy":this.globals.userId
        };
        
        this.saveParticipant(guestUserjsonobj);
      }
      e.preventDefault();
      return false;
    }
    return true;
  }

  
  attendeePresentAnchorTag(event: any, e: any,attjson:any,indexOfAtt:any) {
      
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    if (attjson.attendeeIsPresent == "Y") {
      this.tenLabel = "N";
      var attendeePresent = "N";
if(attjson.logType == null){
        this.logChange(attjson,indexOfAtt,true);
      }
      // this.attendeeLog(null,attjson,indexOfAtt,true);
    } else {
      attendeePresent = "Y";
if(attjson.logType == null){
        this.logChange(attjson,indexOfAtt,false);
      }
      // this.attendeeLog(null,attjson,indexOfAtt,false);
    }
      const attendeePresentJson = {
  
        "attendeeName": attjson.attendeeName,
          "attendeeEmail": attjson.attendeeEmail,
          "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
          "attendeeIsPresent": attendeePresent,
          "attendeeId": e,
          "fkSecUserAttendee": attjson.fkSecUserAttendee,
          "attendeeRole": attjson.attendeeRole,
          //"createdBy": this.attUserId,
          "attendeeRoleCode": attjson.attendeeRoleCode,
          //"deletedFlag": 0,
          "meetingId":attjson.meetingId,
          "userType":this.globals.userType,
          "orgId":this.globals.orgId,
          "userId":this.globals.userId,
          "isUpdate":"Y"
  
      }
      
      this.attendeeService.editAttendee(attendeePresentJson).subscribe((data: any) => {
        this.notifier.notify("success", "Data Saved Successfully");
        
        //attjson.logType = data.logType;
        attjson.attendeeIsPresent = data.attendeeIsPresent;
        if(this.meetingResponse.attendeeList!=undefined && this.meetingResponse.attendeeList!=null){
          this.meetingResponse.attendeeList[indexOfAtt] = attjson;
        }
      });
    }


  attendeePresent(event: any, e: any,attjson:any,indexOfAtt:any) {
  
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    if (event.target.checked) {
      this.tenLabel = "N";
      var attendeePresent = "Y";
      
      const toggleAccess = (<HTMLInputElement>document.getElementById(e + '+slider-input'))
      
      if(toggleAccess?.disabled){
        toggleAccess.disabled = false;
        //toggleAccess.checked = true;
      }
       if (toggleAccess?.checked == false) {
        if(attjson.logType == null){
          this.logChange(attjson,indexOfAtt,false);
        }
      }
      // let btnAccess = (<HTMLButtonElement>document.getElementById(e + '+btn'))
      // btnAccess.disabled = false
    } else {

      event.target.checked = false;
      attendeePresent = "N";
      const toggleAccess = (<HTMLInputElement>document.getElementById(e + '+slider-input'))

      if (toggleAccess?.checked == true) {
        if(attjson.logType == null){
        this.logChange(attjson,indexOfAtt,true);
      }

      }else if(toggleAccess?.checked == false){
      }
      // let btnAccess = (<HTMLButtonElement>document.getElementById(e + '+btn'))
      // btnAccess.disabled = true
    }
    const attendeePresentJson = {

      "attendeeName": attjson.attendeeName,
        "attendeeEmail": attjson.attendeeEmail,
        "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
        "attendeeIsPresent": attendeePresent,
        "attendeeId": e,
        "fkSecUserAttendee": attjson.fkSecUserAttendee,
        "attendeeRole": attjson.attendeeRole,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": attjson.attendeeRoleCode,
        //"deletedFlag": 0,
        "meetingId":attjson.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "isUpdate":"Y"

    }
    
    this.attendeeService.editAttendee(attendeePresentJson).subscribe((data: any) => {
      this.notifier.notify("success", "Data Saved Successfully");
      
      //attjson.logType = data.logType;
      attjson.attendeeIsPresent = data.attendeeIsPresent;
      if(this.meetingResponse.attendeeList!=undefined && this.meetingResponse.attendeeList!=null){
        this.meetingResponse.attendeeList[indexOfAtt] = attjson;
      }
    });
  }

  attendeeSwitchDisable(attobj:any){

    if(attobj.attendeeIsPresent == 'N'){
      return true;
    }else{
      return false;
    }
    
  }

  

  onAttendeeRoleChange(objatt: any, attjson: any) {
    
  //OverWrite Attendee or Note Taker to Facilitator without having Chairperson and have one Facilitator.
    if (($("#displayAttendeeSec").find('div#roleCode_FAC').length > 0 && objatt == "FAC") && (this.roleCodeVal == "ATT" || this.roleCodeVal == "NT")) {
      
      this.dialog.open(ConfirmDialogComponent, {
          
        data: {
          dialogTitle : "Confirmation",
          dialogContent : environment_msg.msg_confirm_change_facilitator
        },
      }).afterClosed().subscribe(response => {

        if(response == true){
          
          const index = this.meetingResponse.attendeeList?.indexOf(this.attendeeJson);
            //
            if (index !== -1 && index != null) {
    
              const changeFacasAttobj =
              {
                "attendeeName": this.attendeeJson.attendeeName,
                "attendeeEmail": this.attendeeJson.attendeeEmail,
                "fkCodelstAttendeeRole": this.attendeeJson.fkCodelstAttendeeRole,
                "attendeeIsPresent": this.attendeeJson.attendeeIsPresent,
                "attendeeId": this.attendeeJson.attendeeId,
                "fkSecUserAttendee": this.attendeeJson.fkSecUserAttendee,
                "attendeeRole": this.attendeeJson.attendeeRole,
                "createdBy": this.attendeeJson.createdBy,
                "attendeeRoleCode": this.roleCodeVal,
                "deletedFlag": 0,
                "logType": "IN",
                "availableStatus": this.attendeeJson.availableStatus,
                "isJoined":this.attendeeJson.isJoined,
              }
              this.meetingResponse.attendeeList?.splice(index, 1, changeFacasAttobj);
              
              this.attendeeService.editAttendee(changeFacasAttobj).subscribe((data: any) => {
                
                attjson.attendeeRoleCode = data.attendeeRoleCode;
                attjson.attendeeId = data.attendeeId;
                attjson = data;
              });
            }

            const index2 = this.meetingResponse.attendeeList?.indexOf(attjson);
            //
            if (index2 !== -1 && index2 != null) {
    
              const changeAttasFACobj =
              {
                "attendeeName": attjson.attendeeName,
                "attendeeEmail": attjson.attendeeEmail,
                "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
                "attendeeIsPresent": attjson.attendeeIsPresent,
                "attendeeId": attjson.attendeeId,
                "fkSecUserAttendee": attjson.fkSecUserAttendee,
                "attendeeRole": attjson.attendeeRole,
                "createdBy": attjson.createdBy,
                "attendeeRoleCode": this.attendeeJson.attendeeRoleCode,
                "deletedFlag": 0,
                "logType": "IN",
                "availableStatus": attjson.availableStatus,
                "isJoined":attjson.isJoined,
                "meetingDateStr":this.meetingResponse.meetingDateShortFormat
              }
              this.meetingResponse.attendeeList?.splice(index2, 1, changeAttasFACobj);
              this.attendeeService.editAttendee(changeAttasFACobj).subscribe((data: any) => {
                
                attjson.attendeeRoleCode = data.attendeeRoleCode;
                attjson.attendeeId = data.attendeeId;
                attjson = data;
              });
            }
        }else{
          this.attendeeService.fetchAttendeeById(attjson.attendeeId).subscribe((dataObj: any) => {
            //
            const index = this.meetingResponse.attendeeList?.indexOf(attjson);
            //
            if (index !== -1 && index != null) {
    
              const attobj =
              {
                "attendeeName": dataObj.attendeeName,
                "attendeeEmail": dataObj.attendeeEmail,
                "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
                "attendeeIsPresent": dataObj.attendeeIsPresent,
                "attendeeId": dataObj.attendeeId,
                "fkSecUserAttendee": dataObj.fkSecUserAttendee,
                "attendeeRole": dataObj.attendeeRole,
                "createdBy": dataObj.createdBy,
                "attendeeRoleCode": dataObj.attendeeRoleCode,
                "deletedFlag": 0,
                "logType": "IN",
                "availableStatus": dataObj.availableStatus,
                "isJoined":dataObj.isJoined,
              }
              this.meetingResponse.attendeeList?.splice(index, 1, attobj);
              //this.sideNav.alertAttendeeRole("attendeeRole");
              
            }
          });

        }

      });
      
    } 
    //changing chairperson to attendee or Note taker without having facilitator or chairperson.
    else if ((($("#displayAttendeeSec").find('div#roleCode_CP').length <= 1 && $("#displayAttendeeSec").find('div#roleCode_FAC').length <=0) && (objatt == "ATT" || objatt == "NT")) && (this.roleCodeVal == "CP")) {
      this.attendeeService.fetchAttendeeById(this.attId).subscribe((dataObj: any) => {
        
        const index = this.meetingResponse.attendeeList?.indexOf(attjson);
        if (index !== -1 && index != null) {

          const attobj =
          {
            "attendeeName": dataObj.attendeeName,
            "attendeeEmail": dataObj.attendeeEmail,
            "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
            "attendeeIsPresent": dataObj.attendeeIsPresent,
            "attendeeId": dataObj.attendeeId,
            "fkSecUserAttendee": dataObj.fkSecUserAttendee,
            "attendeeRole": dataObj.attendeeRole,
            "createdBy": dataObj.createdBy,
            "attendeeRoleCode": dataObj.attendeeRoleCode,
            "deletedFlag": 0,
            "logType": "IN",
            "availableStatus": dataObj.availableStatus,
            "isJoined":dataObj.isJoined,
          }
          this.meetingResponse.attendeeList?.splice(index, 1, attobj);
          this.sideNav.alertChangeFacilitator("attendeeRole");
        }
      });

    }

    //Changing Facilitator into Attendee or Note Taker without having Chairperson
    else if ((this.roleCodeVal == "FAC" && $("#displayAttendeeSec").find('div#roleCode_CP').length <= 0) && (objatt == "NT" || objatt == "ATT")) {

      
      this.attendeeService.fetchAttendeeById(attjson.attendeeId).subscribe((dataObj: any) => {
        
        const index = this.meetingResponse.attendeeList?.indexOf(attjson);
        //
        if (index !== -1 && index != null) {

          const attobj =
          {
            "attendeeName": dataObj.attendeeName,
            "attendeeEmail": dataObj.attendeeEmail,
            "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
            "attendeeIsPresent": dataObj.attendeeIsPresent,
            "attendeeId": dataObj.attendeeId,
            "fkSecUserAttendee": dataObj.fkSecUserAttendee,
            "attendeeRole": dataObj.attendeeRole,
            "createdBy": dataObj.createdBy,
            "attendeeRoleCode": dataObj.attendeeRoleCode,
            "deletedFlag": 0,
            "logType": "IN",
            "availableStatus": dataObj.availableStatus,
            "isJoined":dataObj.isJoined,
          }
          this.meetingResponse.attendeeList?.splice(index, 1, attobj);
        }
        this.sideNav.alertAttendeeRole("attendeeRole");

      });

    }
    //Changing Facilitator to Chairperson
     else if (this.roleCodeVal == "FAC" && objatt == "CP") {

      
      var attroleChangeJson = {
        // "attendeeRoleCode": objatt,
        // "attendeeId": this.attId,
        // "meetingid":attjson.meetingId
        "attendeeName": attjson.attendeeName,
        "attendeeEmail": attjson.attendeeEmail,
        "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
        "attendeeIsPresent": "Y",
        "attendeeId": this.attId,
        "fkSecUserAttendee": attjson.fkSecUserAttendee,
        "attendeeRole": attjson.attendeeRole,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": objatt,
        //"deletedFlag": 0,
        "meetingId":attjson.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "isUpdate":"Y",
        "isJoined":attjson.isJoined
      };

      this.attendeeService.editAttendee(attroleChangeJson).subscribe((data: any) => {
        
        attjson.attendeeRoleCode = data.attendeeRoleCode;
        attjson.attendeeId = data.attendeeId;
      });

      //Changing Facilitator to Attendee or Note Taker having min One chairperson and having max one Facilitator Means. (fac value comes here one) 
    }else if (this.roleCodeVal == "FAC" && ($("#displayAttendeeSec").find('div#roleCode_CP').length > 0 && $("#displayAttendeeSec").find('div#roleCode_FAC').length <= 1) && (objatt == "CP" || objatt == "ATT" || objatt == "NT")) {

      
      var attroleChangeJson = {
        // "attendeeRoleCode": objatt,
        // "attendeeId": this.attId,
        // "meetingid":attjson.meetingId
        "attendeeName": attjson.attendeeName,
        "attendeeEmail": attjson.attendeeEmail,
        "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
        "attendeeIsPresent": "Y",
        "attendeeId": this.attId,
        "fkSecUserAttendee": attjson.fkSecUserAttendee,
        "attendeeRole": attjson.attendeeRole,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": objatt,
        //"deletedFlag": 0,
        "meetingId":attjson.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "isUpdate":"Y",
        "isJoined":attjson.isJoined
      };

      this.attendeeService.editAttendee(attroleChangeJson).subscribe((data: any) => {
        
        attjson.attendeeRoleCode = data.attendeeRoleCode;
        attjson.attendeeId = data.attendeeId;
      });

    }
    //Changing Attendee or Note Taker or Chairperson to Note taker or Chairperson or Attendee.
     else if ((this.roleCodeVal == "ATT" || this.roleCodeVal == "NT" || this.roleCodeVal == "CP") && (objatt == "ATT" || objatt == "NT" || objatt == "CP")) {

      
      const attRlChngJson = {
        // "attendeeRoleCode": objatt,
        // "attendeeId": this.attId,
        // "meetingid":attjson.meetingId
        "attendeeName": attjson.attendeeName,
        "attendeeEmail": attjson.attendeeEmail,
        "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
        "attendeeIsPresent": "Y",
        "attendeeId": this.attId,
        "fkSecUserAttendee": attjson.fkSecUserAttendee,
        "attendeeRole": attjson.attendeeRole,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": objatt,
        //"deletedFlag": 0,
        "meetingId":attjson.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "isUpdate":"Y",
        "isJoined":attjson.isJoined
      };

      this.attendeeService.editAttendee(attRlChngJson).subscribe((data: any) => {
        
        attjson.attendeeRoleCode = data.attendeeRoleCode;
        attjson.attendeeId = data.attendeeId;
      });

    //changing Attendee or Note taker or chairperson to Facilitator having one Chairperson  and without facilitator.
    } else if ((this.roleCodeVal == "ATT" || this.roleCodeVal == "NT" || this.roleCodeVal == "CP") && ($("#displayAttendeeSec").find('div#roleCode_FAC').length <= 0 && $("#displayAttendeeSec").find('div#roleCode_CP').length > 0 && objatt == "FAC")) {

      
      const attRoleChngJson = {
        // "attendeeRoleCode": objatt,
        // "attendeeId": this.attId,
        // "meetingid":attjson.meetingId
        "attendeeName": attjson.attendeeName,
        "attendeeEmail": attjson.attendeeEmail,
        "fkCodelstAttendeeRole": attjson.fkCodelstAttendeeRole,
        "attendeeIsPresent": "Y",
        "attendeeId": this.attId,
        "fkSecUserAttendee": attjson.fkSecUserAttendee,
        "attendeeRole": attjson.attendeeRole,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": objatt,
        //"deletedFlag": 0,
        "meetingId":attjson.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "isUpdate":"Y",
        "isJoined":attjson.isJoined
      };

      this.attendeeService.editAttendee(attRoleChngJson).subscribe((data: any) => {
      

      attjson.attendeeRoleCode = data.attendeeRoleCode;
      attjson.attendeeId = data.attendeeId;

      });
    }
    // changing attendee or note taker or chairperson to facilitator having one facilitator means.
    else if(($("#displayAttendeeSec").find('div#roleCode_FAC').length <= 1 && objatt == "FAC") && (this.roleCodeVal == "ATT" || this.roleCodeVal == "NT" || this.roleCodeVal == "CP")){

      this.attendeeService.fetchAttendeeById(attjson.attendeeId).subscribe((dataObj: any) => {
        //
        const index = this.meetingResponse.attendeeList?.indexOf(attjson);
        //
        if (index !== -1 && index != null) {

          const attobj =
          {
            "attendeeName": dataObj.attendeeName,
            "attendeeEmail": dataObj.attendeeEmail,
            "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
            "attendeeIsPresent": dataObj.attendeeIsPresent,
            "attendeeId": dataObj.attendeeId,
            "fkSecUserAttendee": dataObj.fkSecUserAttendee,
            "attendeeRole": dataObj.attendeeRole,
            "createdBy": dataObj.createdBy,
            "attendeeRoleCode": dataObj.attendeeRoleCode,
            "deletedFlag": 0,
            "logType": "IN",
            "availableStatus": dataObj.availableStatus,
            "isJoined":dataObj.isJoined
          }
          this.meetingResponse.attendeeList?.splice(index, 1, attobj);
        }

        this.sideNav.alertMultiFacilitator("changeFAC");
        //this.meetingResponse.attendeeList?.push(attobj);

      });
    }
    else {

      this.attendeeService.fetchAttendeeById(attjson.attendeeId).subscribe((dataObj: any) => {
        //
        const index = this.meetingResponse.attendeeList?.indexOf(attjson);
        //
        if (index !== -1 && index != null) {

          const attobj =
          {
            "attendeeName": dataObj.attendeeName,
            "attendeeEmail": dataObj.attendeeEmail,
            "fkCodelstAttendeeRole": dataObj.fkCodelstAttendeeRole,
            "attendeeIsPresent": dataObj.attendeeIsPresent,
            "attendeeId": dataObj.attendeeId,
            "fkSecUserAttendee": dataObj.fkSecUserAttendee,
            "attendeeRole": dataObj.attendeeRole,
            "createdBy": dataObj.createdBy,
            "attendeeRoleCode": dataObj.attendeeRoleCode,
            "deletedFlag": 0,
            "logType": "IN",
            "availableStatus": dataObj.availableStatus,
            "isJoined":dataObj.isJoined
          }
          this.meetingResponse.attendeeList?.splice(index, 1, attobj);
        }
      });
    }
  }
  roleCodeValues(code: any) {
    const role = this.roleListData.find((role: { code: any; }) => role.code === code);
    return role ? role.description : '';
  }
  
  attendeeLog(event: any, objAttJson: any,indexOfAtt:any,attLogFlag:any) {

    const currentTime = this.utility.getCurrentTimeBasedOnVisiterTimezone();
    
    if ((attLogFlag == true && event == null) || (event != null && event.checked == false)) {
      
      var jsonObj = {
        "attendeeName": objAttJson.attendeeName,
        "attendeeUserId": objAttJson.fkSecUserAttendee,
        "logType": "OUT",
        "meetingId": this.meetingResponse.meetingId,
        "currentTime": currentTime,
        "attendeeId": objAttJson.attendeeId,
        "absentType": "Time",
        "attendeeLogId": "",
        "meetingDate": this.meetingResponse.meetingDateFullFormat,
        "timeZone": this.globals.vTimeZone,
        "createdBy": this.globals.userId,
        "orgCode": this.globals.orgCode
      };
    }
    else {
      
      var jsonObj = {
        "attendeeName": objAttJson.attendeeName,
        "attendeeUserId": objAttJson.fkSecUserAttendee,
        "logType": "IN",
        "meetingId": this.meetingResponse.meetingId,
        "currentTime": currentTime,
        "attendeeId": objAttJson.attendeeId,
        "absentType": "Time",
        "attendeeLogId": "",
        "meetingDate": this.meetingResponse.meetingDateFullFormat,
        "timeZone": this.globals.vTimeZone,
        "createdBy": this.globals.userId,
        "orgCode": this.globals.orgCode
      };
    }
    this.attendeeService.saveAttendeeLog(jsonObj).subscribe((data: any) => {
      
      objAttJson.logType = data.logType;
      if(this.meetingResponse.attendeeList!=undefined && this.meetingResponse.attendeeList!=null){
        this.meetingResponse.attendeeList[indexOfAtt] = objAttJson;
      }
    });





  }

  toggleIcon(){
    const participantIcon = <HTMLElement>document.getElementById('accordion-header-0');
    const participantAccIcon = <HTMLElement>document.getElementById('participant-accordion-container');
    // participantIcon.click()
    
    // if(participantIcon.getAttribute('expanded') == 'false'){
      // participantIcon.removeAttribute('expanded');
      // participantIcon.setAttribute('expanded','true')
      // participantAccIcon.click()
    // }
  }

  attendeeLogLabel(event: any) {
    if (event.checked == true) {
      this.myFlagForSlideToggle = true;
    } else {
      this.myFlagForSlideToggle = false;
    }

  }

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  logChange(objAttJson: any,indexOfAtt:any, attLogFlag:any){
    
    if(attLogFlag == true){
      objAttJson.logType = 'OUT';

    }else{
      objAttJson.logType = 'IN';
    }
    if(this.meetingResponse.attendeeList!=undefined && this.meetingResponse.attendeeList!=null){
      this.meetingResponse.attendeeList[indexOfAtt] = objAttJson;
    }
  }
}
